export default "__VITE_PUBLIC_ASSET__78b2a0f5__"